// extracted by mini-css-extract-plugin
export default {"panelSuite":"DiazarSuiteModal_panelSuite__aCRsq","panelSuiteActive":"DiazarSuiteModal_panelSuiteActive__SnHhs"};